<span class="time-ago">{{ calculateTime(dateTime) }}</span>